import { useState } from 'react';
import { Mail, CheckCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');

    try {
      await axios.post(`${API}/newsletter/subscribe`, { email, name });
      setSubmitSuccess(true);
      setEmail('');
      setName('');
      setTimeout(() => setSubmitSuccess(false), 5000);
    } catch (error) {
      console.error('Error subscribing:', error);
      setSubmitError(error.response?.data?.detail || 'Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitSuccess) {
    return (
      <div data-testid="newsletter-success" className="p-6 bg-accent/20 border border-accent rounded-lg flex items-center justify-center space-x-3">
        <CheckCircle className="text-accent" size={24} />
        <p className="text-accent-foreground font-medium">Thank you for subscribing!</p>
      </div>
    );
  }

  return (
    <div data-testid="newsletter-signup">
      {submitError && (
        <div data-testid="newsletter-error" className="mb-4 p-4 bg-destructive/20 border border-destructive rounded-lg">
          <p className="text-destructive text-sm">{submitError}</p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto">
        <input
          type="text"
          data-testid="newsletter-name-input"
          placeholder="Name (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="flex-1 px-6 py-4 rounded-full border border-border bg-background focus:outline-none focus:ring-2 focus:ring-accent transition-all"
        />
        <input
          type="email"
          data-testid="newsletter-email-input"
          placeholder="Enter your email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="flex-1 px-6 py-4 rounded-full border border-border bg-background focus:outline-none focus:ring-2 focus:ring-accent transition-all"
        />
        <button
          type="submit"
          data-testid="newsletter-submit-button"
          disabled={isSubmitting}
          className="inline-flex items-center justify-center bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8 py-4 font-medium transition-all hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 whitespace-nowrap"
        >
          {isSubmitting ? (
            'Subscribing...'
          ) : (
            <>
              <Mail className="mr-2" size={20} />
              Subscribe
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default NewsletterSignup;